export { default } from "./RecentSearches";
